import type { Ad } from '../../types';
import AdCard from './AdCard';
import './AdCardList.css';

interface AdCardListProps {
  ads: Ad[];
  loading?: boolean;
  onAdClick?: (adId: string) => void;
}

/**
 * 廣告卡片列表元件
 * [UPDATED v0.7.1] 對齊後端 API
 * 對應 UXC-advertising-AdCardList-004
 */
const AdCardList = ({ ads, loading = false, onAdClick }: AdCardListProps) => {
  if (loading) {
    return (
      <div className="ad-card-list">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className="ad-card-skeleton">
            <div className="skeleton skeleton-image"></div>
            <div className="skeleton skeleton-title"></div>
            <div className="skeleton skeleton-text"></div>
            <div className="skeleton skeleton-text"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="ad-card-list">
      {ads.map((ad) => (
        <AdCard key={ad.id} ad={ad} onClick={onAdClick} />
      ))}
    </div>
  );
};

export default AdCardList;
